<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>
          <template v-if="prestamoRefId">
            <span>{{ tipoPrestamo === 'RN' ? "Renovación de " : "Refinanciamiento de " }}</span>
          </template>
          Préstamo <span>{{ selectedCliente !== null ? selectedCliente.solo_descripcion ||
            selectedCliente.descripcion.split('(')[0].trim() : '' }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="datepicker-field">
            <VueCtkDateTimePicker id="fecha_desembolso" v-model="form.fecha_desembolso" locale="es" no-label
              button-now-translation="Ahora" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm"
              label="Seleccione fecha..." />
            <label>Fecha de desembolso</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select2" :class="{ 'select2--readonly': prestamoRefId != '' }">
          <div class="select2-field">
            <v-select @search="onSearchClientes" id="cliente" v-model="selectedCliente" @input="inputCliente"
              placeholder="Seleccione..." :options="clientes" label="descripcion"></v-select>
            <label for="cliente">Cliente</label>
            <span v-if="errores.cliente_id" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.cliente_id[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select2" :class="{ 'select2--disabled': prestamoRefId != '' || ruta }">
          <div class="select2-field">
            <v-select @input="inputRuta" id="ruta_id" v-model="selectedRuta" :options="rutas" @search="onSearchRutas"
              label="descripcion"></v-select>
            <label for="ruta">Ruta</label>
            <span v-if="errores.ruta_id" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.ruta_id[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select">
          <div class="select-field">
            <select v-model="form.periodo" name="periodo" id="tipo_identificacion">
              <option value="">Seleccione...</option>
              <option value="D">Diario</option>
              <option value="S">Semanal</option>
              <option value="M">Mensual</option>
            </select>
            <label for="periodo">Período</label>
            <span v-if="errores.periodo" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.periodo[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div v-if="form.periodo === 'M'" class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field vMoney :format="int" placeholder="Escriba el día de cobro..." id="dia_cobro"
            v-model="form.dia_cobro">
            Día de cobro
            <span v-if="errores.dia_cobro" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.dia_cobro[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div v-if="form.periodo === 'S'" class="col-xs-12 col-md-6">
        <div class="form-field select">
          <div class="select-field">
            <select v-model="form.dia_cobro" id="dia_cobro">
              <option value="" disabled>Seleccione...</option>
              <option value="1">Lunes</option>
              <option value="2">Martes</option>
              <option value="3">Miércoles</option>
              <option value="4">Jueves</option>
              <option value="5">Viernes</option>
              <option value="6">Sábado</option>
              <!-- <option value="0">Domingo</option> -->
            </select>
            <label for="dia_cobro">Día de cobro</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field vMoney :format="money" placeholder="Escriba un valor..." id="valor" v-model="form.valor"
            @keyup.native="generarAmortizaciones" :readonly="tipoPrestamo === 'RF'">
            Valor
            <span v-if="errores.valor" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.valor[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field vMoney :format="porcentaje" :readonly="!puedeCambiarInteres" placeholder="Escriba un % interés..."
            id="porc_interes" v-model="form.porc_interes" @keyup.native="generarAmortizaciones">
            % Interés
            <span v-if="errores.porc_interes" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.porc_interes[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field readonly vMoney :format="money" placeholder="Total calculado..." id="total" :value="total">
            Total
            <span v-if="errores.total" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.total[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field vMoney :format="int" placeholder="Escriba la cantidad de cuotas..." id="cuotas"
            v-model="form.cuotas" @keyup.native="generarAmortizaciones">
            Cuotas
            <span v-if="errores.cuotas" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.cuotas[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="table-responsive">
          <table>
            <thead>
              <tr>
                <th>Direcciones</th>
                <th>
                  <div>
                    <button type="button" @click="agregarDireccion" class="btn-success">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(direccion, index) in form.direcciones" :key="index">
                <td>
                  <div class="form-field">
                    <input-field v-model="direccion.direccion" :id="'direccion' + index"></input-field>
                  </div>
                </td>
                <td>
                  <button type="button" @click="eliminarDireccion(index)" class="btn-danger btn--text">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
              <tr v-show="form.direcciones.length === 0">
                <td colspan="2">
                  <strong>No se ha agregado dirección alguna...</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-xs-12 col-md-6" style="max-height: 420px; overflow-y: auto;">
        <div class="table-responsive">
          <table>
            <thead>
              <tr>
                <th>Cuota</th>
                <th>Valor</th>
                <th>Total pagado</th>
                <th>Saldo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(amortizacion, index) in form.amortizaciones" :key="index">
                <th scope="row">
                  {{ amortizacion.cuota }}
                </th>
                <td>
                  {{ moneyFormat(amortizacion.valor, 2) }}
                </td>
                <td>
                  {{ moneyFormat(amortizacion.total_pagado, 2) }}
                </td>
                <td>
                  {{ moneyFormat(amortizacion.saldo, 2) }}
                </td>
              </tr>
              <tr v-show="form.amortizaciones.length === 0">
                <td colspan="4">
                  <strong>No se ha generado amortizaciones...</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button v-if="prestamoId != ''" @click="auditoria" class="btn-secondary">
        <i class="fa fa-list"></i><span>Auditoría</span>
      </button>
      <button @click="guardar" class="btn-success">
        <i class="fa fa-save"></i><span>Guardar</span>
      </button>
      <button @click="cancelar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cancelar</span>
      </button>
    </div>
    <modal name="auditoriaPrestamo" scrollable reset adaptive resizable height="auto" width="50%" clickToClose>
      <auditoria-prestamo :prestamoId="prestamoId"></auditoria-prestamo>
    </modal>
  </div>
</template>

<script>
import AuditoriaPrestamo from "./AuditoriaPrestamo.vue";
export default {
  components: {
    AuditoriaPrestamo,
  },
  computed: {
    total: function () {
      let total = 0;
      let valor = parseFloat(this.form.valor);
      if (isNaN(valor)) valor = 0;
      let interes = parseFloat(this.form.porc_interes);
      if (isNaN(interes)) interes = 0;
      total = round(valor * (1 + interes / 100), 2);
      this.form.total = total;
      return total;
    },
  },
  props: {
    puedeCambiarInteres: {
      type: Boolean,
      required: false,
      default: false,
    },
    prestamoId: {
      required: false,
      default: "",
    },
    // Aplica al refinanciar/renovar préstamo
    prestamoRefId: {
      required: false,
      default: "",
    },
    valorPagoRf: {
      required: false,
      default: 0,
    },
    tipoPrestamo: {
      required: false,
      default: "N",
    },
    porcInteres: {
      required: false,
      default: 6,
    },
    cuotas: {
      required: false,
      default: 0
    },
    ruta: {
      required: false,
      default: null
    },
    fechaRutaCobro: {
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      moneyFormat: moneyFormat,
      int: int,
      porcentaje: porcentaje,
      money: money,
      form: {
        fecha_desembolso: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        cliente_id: "",
        ruta_id: "",
        valor: "",
        porc_interes: this.porcInteres,
        cuotas: this.cuotas,
        periodo: "D",
        direcciones: [],
        total: 0,
        amortizaciones: [],
        dia_cobro: "",
        prest_ref_id: "",
        tipo_prestamo: this.tipoPrestamo,
        fecha_ruta_cobro: this.fechaRutaCobro
      },
      errores: {},
      clientes: [],
      rutas: [],
      selectedCliente: null,
      selectedRuta: null,
    };
  },
  methods: {
    auditoria: function () {
      this.$modal.show("auditoriaPrestamo");
    },
    generarAmortizaciones: function () {
      let total = this.total;
      let cuotas = parseInt(this.form.cuotas);
      if (isNaN(cuotas)) cuotas = 0;
      this.form.amortizaciones.splice(0, this.form.amortizaciones.length);
      if (cuotas > 0) {
        let valorCuota = round(total / cuotas, 2);
        let acumuladoCuotas = 0;
        for (let i = 0; i < cuotas; i++) {
          acumuladoCuotas += valorCuota;
          let item = {
            cuota: i + 1,
            valor: valorCuota,
            total_pagado: 0,
            saldo: valorCuota,
          };
          acumuladoCuotas = round(acumuladoCuotas, 2);
          if (i == cuotas - 1) {
            if (acumuladoCuotas != total) {
              let adicional = round(total - acumuladoCuotas, 2);
              acumuladoCuotas += adicional;
              item.valor += adicional;
              item.valor = round(item.valor, 2);
              acumuladoCuotas = round(acumuladoCuotas, 2);
            }
          }
          this.form.amortizaciones.push(item);
        }
      }
    },
    eliminarDireccion: function (index) {
      this.form.direcciones.splice(index, 1);
    },
    agregarDireccion: function () {
      this.form.direcciones.push({
        direccion: "",
      });
    },
    onSearchRutas: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.rutas = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/rutas?search=" + search, true);
      xmlhttp.send();
    },
    inputRuta: function () {
      if (this.selectedRuta != null) this.form.ruta_id = this.selectedRuta.id;
      else this.form.ruta_id = "";
    },
    inputCliente: function () {
      if (this.selectedCliente != null)
        this.form.cliente_id = this.selectedCliente.id;
      else this.form.cliente_id = "";
    },
    onSearchClientes: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.clientes = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/clientes?search=" + search, true);
      xmlhttp.send();
    },
    guardar: function () {
      if (this.form.periodo === "M") {
        let diaCobro = parseInt(this.form.dia_cobro);
        if (isNaN(diaCobro)) diaCobro = 0;
        if (diaCobro < 1 || diaCobro > 31) {
          swal.fire(
            "El día de cobro debe estar entre valores de 1 y 31.",
            "Aviso",
            "warning"
          );
          return;
        }
      }
      swal({
        title: "¿Desea almacenar el préstamo?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let urlApi = "";
          if (this.prestamoId != "")
            urlApi = `${url}/prestamos/editar/${this.prestamoId}`;
          else urlApi = `${url}/prestamos`;
          axios
            .post(urlApi, this.form)
            .then(({ data }) => {
              swal("El préstamo fue almacenado con éxito.", "Aviso", "success");
              this.$emit("guardar", data.prestamo);
            })
            .catch((error) => {
              let { response } = error;
              if (response.status == 403) {
                swal("Error", "No tiene permisos.", "error");
                return;
              }
              if (response.status == 409) {
                const msg = response.data.error;
                swal("Error", msg, "error");
                return;
              }
              if (response.status == 422) {
                this.errores = response.data.errors;
                swal("Hay errores en el formulario.", "Aviso", "warning");
                return;
              }
              swal("Error", "No se pudo almacenar el préstamo", "error");
            });
        }
      });
    },
    cancelar: function () {
      this.$emit("cerrar");
    },
    cargarPrestamo: function () {
      const id = this.prestamoId || this.prestamoRefId;
      let urlApi = `${url}/prestamos/cargar-prestamo/${id}`;
      axios
        .get(urlApi)
        .then((response) => {
          let prestamo = response.data.prestamo;
          // const valorPagoRf = round(parseFloat(this.valorPagoRf), 2);
          this.form.amortizaciones.splice(0, this.form.amortizaciones.length);
          this.form.cliente_id = prestamo.cliente_id;
          this.selectedCliente = prestamo.cliente;
          this.form.ruta_id = prestamo.ruta_id;
          this.selectedRuta = prestamo.ruta;
          if (this.prestamoRefId != "") {
            this.form.fecha_ruta_cobro = this.fechaRutaCobro;
            this.form.fecha_desembolso = moment(
              new Date([this.fechaRutaCobro, [new Date().getHours(), new Date().getMinutes()].join(':')])
            ).format("YYYY-MM-DD HH:mm");
            this.form.prest_ref_id = this.prestamoRefId;
            this.form.porc_interes = this.porcInteres;
            this.form.cuotas = this.cuotas;
            this.form.periodo = 'D';
            if (this.tipoPrestamo === 'RN') {
              this.form.valor = 0;
            } else if (this.tipoPrestamo === 'RF') {
              // this.form.valor = round(parseFloat(prestamo.saldo) + valorPagoRf, 2);
              this.form.valor = round(parseFloat(prestamo.saldo), 2);
              this.generarAmortizaciones();
            }
          } else {
            this.form.tipo_prestamo = prestamo.tipo_prestamo;
            this.form.valor = prestamo.valor;
            this.form.porc_interes = prestamo.porc_interes;
            this.form.dia_cobro = prestamo.dia_cobro;
            this.form.cuotas = prestamo.cuotas;
            this.form.periodo = prestamo.periodo;
            this.form.fecha_desembolso = moment(
              new Date(prestamo.fecha_desembolso)
            ).format("YYYY-MM-DD HH:mm");
            this.form.prest_ref_id = "";
            for (let i = 0; i < prestamo.amortizaciones.length; i++) {
              this.form.amortizaciones.push({
                cuota: prestamo.amortizaciones[i].cuota,
                valor: prestamo.amortizaciones[i].valor,
                total_pagado: prestamo.amortizaciones[i].total_pagado,
                saldo: prestamo.amortizaciones[i].saldo,
              });
            }
          }
          this.form.direcciones.splice(0, this.form.direcciones.length);
          for (let i = 0; i < prestamo.direcciones.length; i++) {
            this.form.direcciones.push({
              direccion: prestamo.direcciones[i].direccion,
            });
          }
        })
        .catch((error) => {
          swal("Error", "Hubo un error al cargar el préstamo", "error");
        });
    },
  },
  mounted: function () {
    if (this.ruta) {
      this.selectedRuta = this.ruta;
      this.form.ruta_id = this.ruta.id;
    }
    if (this.prestamoId != "" || this.prestamoRefId != "")
      this.cargarPrestamo();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/prestamos/Prestamo.vue